import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

export const AttachmentNameColumn = ({ data }: Props) => {
	return <>{data?.FileName}</>;
};
